export default class Popups {
  constructor(node, index) {
    this.node = node
    this.index = index

    this.button = this.node.querySelector('.popup-button')

    this.clickAction = this.clickAction.bind(this)

    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    this.button.addEventListener('click', this.clickAction)
  }

  clickAction(e) {
    this.node.classList.toggle('open')
  }

  reset() {
    this.node.classList.remove('open')
  }

  destroy() {
    this.button.removeEventListener('click', this.clickAction)
    this.reset()
  }

  static resetAll() {
    setTimeout(() => {
      Popups.items.forEach((elem) => {
        elem.reset()
      })
    }, 500)
  }

  static destroyAll() {
    Popups.items.forEach((elem) => {
      elem.destroy()
    })
  }

  static init() {
    Popups.items = Array.from(document.querySelectorAll('.popup')).map(
      (node, index) => new Popups(node, index)
    )
  }
}
